module.exports = __webpack_public_path__ + "static/img/scene2.ce7bcd59.jpg";